// extracted by mini-css-extract-plugin
module.exports = {"root":"_1vtHO","headerWrapper":"_1OJ53","pagesWrapper":"_2Xpim","inModal":"_13eHp"};